import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Import HomeScreen
import HomeScreen from './components/HomeScreen';

// Import Blogs
import BlogsScreen from './components/BlogsScreen';
import FullBlog from './components/FullBlog';

// Import New Navbar Components
import Tours from './components/NavbarComponents/Tours';
import Destinations from './components/NavbarComponents/Destinations';
import VisaServices from './components/NavbarComponents/VisaServices';
import Hotels from './components/NavbarComponents/Hotels';
import AboutUs from './components/NavbarComponents/AboutUs';
import Contact from './components/NavbarComponents/Contact';
import DestinationDetail from './components/DestinationDetail';
import Flights from './components/NavbarComponents/Flights';
import MICE from './components/NavbarComponents/MICE';
import ScrollToTop from './components/ScrollToTop';
import AllServices from './components/AllServices';
import TourDetail from "./components/NavbarComponents/TourDetail";

function App() {
  return (
    <Router>
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/blogs" element={<BlogsScreen />} />
        <Route path="/blogs/:id" element={<FullBlog />} />
        <Route path="/tours" element={<Tours />} />
        <Route path="/destinations" element={<Destinations />} />
        <Route path="/visa" element={<VisaServices />} />
        <Route path="/hotels" element={<Hotels />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/destinations/:id" element={<DestinationDetail />} />
        <Route path="/flights" element={<Flights />} />
        <Route path="/mice" element={<MICE />} />
        <Route path="/services" element={<AllServices />} />
        <Route path="/tours/:id" element={<TourDetail />} />
      </Routes>
    </Router>
  );
}

export default App;